

import React, { useRef } from 'react'
import { RoundedBox, useTexture } from '@react-three/drei'
import { PreviewDestinationOutlines } from "../../PreviewDestinationOutlines"

export function RoundedWindow({ showDestinationOutline, ...props }) {
    const group = useRef()

    return (
        <group visible={props.colour ? true : false} ref={group} {...props} dispose={null} onClick={(e) => {e.stopPropagation() 
            props.clickFunction()}}>
            <RoundedBox position={[0,0.5,0]} args={[1, 1, 0.05]} radius={0.05} smoothness={4} >
                <meshPhongMaterial
                    receiveShadow
                    color={props.colour}
                    attach="material"
                    opacity={1}
                    
                />
                {showDestinationOutline && <PreviewDestinationOutlines />}
            </RoundedBox>
        </group>
    )
}
 
export function RoundedWindowTexture({ showDestinationOutline, ...props }) {

    const texture = useTexture(props.imageTexture)
    const group = useRef()

    return (
        <group visible={props.colour ? true : false} ref={group} {...props} dispose={null} onClick={(e) => {e.stopPropagation() 
            props.clickFunction()}}>
            <RoundedBox position={[0,0.5,0]} args={[1, 1, 0.05]} radius={0.05} smoothness={4} >
                <meshPhongMaterial
                    receiveShadow
                    color={props.colour}
                    attach="material"
                    opacity={1}
                    map={texture}

                    
                />
                {showDestinationOutline && <PreviewDestinationOutlines />}
            </RoundedBox>
        </group>
    )
}
 